import { List, Datagrid, TextField } from "react-admin";

import LayoutContainer from "../components/LayoutContainer";

// const useStyles = makeStyles((theme) => ({
//   container: {
//     position: "absolute",
//     top: 0,
//     bottom: 0,
//     left: 0,
//     right: 0,
//     overflow: "auto",
//   },
// }));

const CategoryList = (props) => {
  // const classes = useStyles();
  return (
    <LayoutContainer>
      <List
        {...props}
        //filters={<ProductFilter />}
        perPage={10}
        bulkActionButtons={false}
      >
        <Datagrid rowClick="show">
          <TextField label="Name" source="name" />
          <TextField label="Description" source="desc" />
          <TextField label="Contact" source="contact1" />
        </Datagrid>
      </List>
    </LayoutContainer>
  );
};
/**
 * <ReferenceManyField
          label="Amount"
          target="product_id"
          reference="stock"
        >
          <SingleFieldList>
            <ChipField source="remaining" />
          </SingleFieldList>
        </ReferenceManyField>
 */
export default CategoryList;
